import { render, staticRenderFns } from "./FFMenu.vue?vue&type=template&id=7af4b84b&scoped=true&"
import script from "./FFMenu.vue?vue&type=script&lang=js&"
export * from "./FFMenu.vue?vue&type=script&lang=js&"
import style0 from "./FFMenu.vue?vue&type=style&index=0&id=7af4b84b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af4b84b",
  null
  
)

export default component.exports